import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnInstanceExperimentsUrl } from './paths';
import type { AbnCreateExperimentResponse, CreateAbnExperimentParams } from './types';

export async function createAbnExperiment(instanceName: string, params: CreateAbnExperimentParams) {
  /* eslint-disable camelcase */
  const body: Record<string, unknown> = {
    experiment_name: params.experimentName,
    control: params.control,
    variations: params.variations,
  };
  /* eslint-enable camelcase */
  if (params.splits?.length) body.splits = params.splits;

  const response = await api.executePostRequest<ObjectResponse<AbnCreateExperimentResponse>>(
    abnInstanceExperimentsUrl(instanceName),
    body
  );

  return response.data;
}
